module.exports = __webpack_public_path__ + "static/img/d4-3xx.36e98ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/home/mobile/role/d4-3xx.png
// module id = X89r
// module chunks = 0